import { SET, RESET_STATE } from "@/stores/CommumActionTypes";
import {
	CLOSE_DRAWER,
	TOGGLE_STRATIFICATION,
	TOGGLE_CUSTOM_DOMAIN,
	OPEN_DRAWER,
	TOGGLE_CUSTOM_DOMAIN_COMPARISON,
} from "./AdvancedSettingsDrawerActionType";

const actions = {
	[SET]: ({ commit }, value) =>
	{
		commit(SET, value);
	},
	[TOGGLE_CUSTOM_DOMAIN]: ({ commit }, value) =>
	{
		commit(TOGGLE_CUSTOM_DOMAIN, value);
	},
	[TOGGLE_STRATIFICATION]: ({ commit }, view) =>
	{
		commit(TOGGLE_STRATIFICATION, view);
	},
	[TOGGLE_CUSTOM_DOMAIN_COMPARISON]: ({ commit }, view) =>
	{
		commit(TOGGLE_CUSTOM_DOMAIN_COMPARISON, view);
	},
	[OPEN_DRAWER]: ({ commit }) =>
	{
		commit(OPEN_DRAWER);
	},
	[CLOSE_DRAWER]: ({ commit }) =>
	{
		commit(CLOSE_DRAWER);
	},
	[RESET_STATE]: ({ dispatch, commit }) =>
	{
		commit(RESET_STATE);
		dispatch(`CustomDomain/${RESET_STATE}`);
		dispatch(`Stratification/${RESET_STATE}`);
	}
};

export default { actions };
